import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-delete-dialog',
    templateUrl: './confirm-delete-dialog.component.html',
    styleUrls: ['./confirm-delete-dialog.component.scss'],
})
export class ConfirmDeleteDialogComponent {
    @Output() confirm = new EventEmitter<boolean>();

    constructor(
        private dialogRef: MatDialogRef<ConfirmDeleteDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: { title: string; body: string[]; loading: boolean },
    ) {}

    cancel() {
        this.dialogRef.close(false);
    }

    handleConfirm() {
        this.confirm.emit(true);
    }
}
